/* @flow */

import React from 'react'
import styled from 'styled-components'
import { Modal } from 'react-bootstrap'

import ActionButton from '../../infrastructure/components/ActionButton'
import ImageDownloadTransformations from '../file-bank/components/ImageDownloadTransformations'

const DownloadDropShippingImagesModal = ({
  onHide,
  onSubmit,
  show,
}: {
  onHide: Function,
  onSubmit: Function,
  show: boolean,
}) => {
  const [transformations, setTransformations] = React.useState([])

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Download images for drop shipping products</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ImageDownloadTransformations
          onChange={setTransformations}
          transformations={transformations}
        />
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-white" onClick={onHide}>
          Cancel
        </button>
        <ActionButton
          className="btn btn-success"
          iconClass="glyphicon glyphicon-ok"
          onClick={() => onSubmit(transformations)}
        >
          Download!
        </ActionButton>
      </Modal.Footer>
    </Modal>
  )
}

export default DownloadDropShippingImagesModal
